import React from 'react';

export const Drag = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="9.16895" cy="19.5" r="1.5" fill={color || '#97A0AF'} />
    <circle cx="9.16895" cy="12.5" r="1.5" fill={color || '#97A0AF'} />
    <circle cx="9.16895" cy="5.5" r="1.5" fill={color || '#97A0AF'} />
    <circle cx="16.1689" cy="19.5" r="1.5" fill={color || '#97A0AF'} />
    <circle cx="16.1689" cy="12.5" r="1.5" fill={color || '#97A0AF'} />
    <circle cx="16.1689" cy="5.5" r="1.5" fill={color || '#97A0AF'} />
  </svg>
);
